import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from "web-vitals";

const reportWebVitals = (onReport?: (metric: Metric) => void) => {
  if (!onReport) return;
  onCLS(onReport);
  onFCP(onReport);
  onINP(onReport);
  onLCP(onReport);
  onTTFB(onReport);
};

export default reportWebVitals;
